module.exports = __webpack_public_path__ + "img/agregar-monedero.9038e51f.png";